module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2016/september-f8013c030c44e93ddd4fad7cc24a8d14.png";